export default "__VITE_ASSET__DGBf$R0w__"